export const PRODUCT_NOTIFY = "PRODUCT_NOTIFY";
export const PRODUCT_NOTIFY_UNSET = "PRODUCT_NOTIFY_UNSET";
